import { Menu, MenuItem, RenderMenuProps, Typeahead } from "react-bootstrap-typeahead";
import { Card, CardBody, Col, Form } from "reactstrap";
import { MultipleSectionsHeadersTitle } from "../../../../../constants";
import { MultipleSelectionSubTitle, MultipleWithHeadersData } from "../../../../../data/formsAndTable/forms/FormWidgets";
import { Option } from "react-bootstrap-typeahead/types/types";
import { MultipleItems } from "../../../../../types/Forms";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

// This component renders a searchable dropdown with multiple sections and headers.
const MultipleSectionsWithHeaders = () => {
  const renderMenu = (results: Option[], menuProps: RenderMenuProps) => {
    const items = results.map((result, index) => {
      const item = result as MultipleItems; // Type assertion

      // Render a divider if the item specifies it
      if (item.divider === true) <li key={index} role="separator" className="divider" />;

      // Render a header if the item specifies it
      if (item.header === true)
        <li key={index} className="dropdown-header">
          {item.name}
        </li>;

      // Render a regular menu item
      return (
        <MenuItem key={index} option={result} position={index}>
          <strong>{item.name}</strong>
        </MenuItem>
      );
    });
    return <Menu {...menuProps}>{items}</Menu>;
  };

  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader title={MultipleSectionsHeadersTitle} span={MultipleSelectionSubTitle} />
        <CardBody>
          <div id="multiple-datasets">
            <Form className="theme-form">
              <div>
                <Typeahead id="multi" options={MultipleWithHeadersData as Option[]} placeholder="NBA and NHL teams" renderMenu={renderMenu} labelKey={(option) => (option as MultipleItems).name} />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default MultipleSectionsWithHeaders;
